import { useEffect, useState } from "react";
import { Descriptions, message, Spin, Row, Col, Form, Input, Button, Switch } from 'antd';
import secureLocalStorage from "react-secure-storage";
import "./RestaurantPage.css";
import { getRestaurantById, listRestaurantCalendars, updateRestaurantById, updateRestaurantCalendarById } from "../../services/restaurants";

export default function RestaurantsInformation() {
    const [restaurantInfo, setRestaurantInfo] = useState(null);
    const [restaurantCalendars, setRestaurantCalendars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [checkRestaurant, setCheckRestaurant] = useState(false);
    const [formValues, setFormValues] = useState({});
    const formatTimeToHHMM = (time) => {
        if (time) {
            const [hours, minutes] = time.split(":");
            return `${hours}:${minutes}`;
        }
        return "00:00";
    };
    useEffect(() => {
        const fetchRestaurantData = async () => {
            try {
                const restaurantId = secureLocalStorage.getItem("restaurant");
                if (!restaurantId) {
                    message.error("ID do restaurante não encontrado no armazenamento local.");
                    return;
                }

                const restaurantData = await getRestaurantById(restaurantId);
                setRestaurantInfo(restaurantData);
                setCheckRestaurant(restaurantData.status === 'active');
                const calendarData = await listRestaurantCalendars();
                const filteredCalendars = calendarData.items.filter(calendar => calendar.restaurant_id === parseInt(restaurantId, 10));
                setRestaurantCalendars(filteredCalendars);

                const initialValues = {};
                filteredCalendars.forEach(calendar => {
                    initialValues[`start_morning_${calendar.id}`] = formatTimeToHHMM(calendar.start_morning);
                    initialValues[`finish_morning_${calendar.id}`] = formatTimeToHHMM(calendar.finish_morning);
                    initialValues[`start_afternoon_${calendar.id}`] = formatTimeToHHMM(calendar.start_afternoon);
                    initialValues[`finish_afternoon_${calendar.id}`] = formatTimeToHHMM(calendar.finish_afternoon);
                    initialValues[`start_night_${calendar.id}`] = formatTimeToHHMM(calendar.start_night);
                    initialValues[`finish_night_${calendar.id}`] = formatTimeToHHMM(calendar.finish_night);
                });
                setFormValues(initialValues);
            } catch (error) {
                message.error("Erro ao buscar informações do restaurante ou horários.");
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchRestaurantData();
    }, []);


    const onChange = async (checked) => {
        try {
            const restaurantId = secureLocalStorage.getItem("restaurant");
            const updatedStatus = checked ? 'active' : 'inactive';

            const updatedRestaurantInfo = { ...restaurantInfo, status: updatedStatus };

            await updateRestaurantById(restaurantId, updatedRestaurantInfo);
            setCheckRestaurant(checked);
            setRestaurantInfo(updatedRestaurantInfo);
            message.success(`Restaurante ${checked ? "ativado" : "desativado"} com sucesso.`);
        } catch (error) {
            console.error("Erro ao atualizar status do restaurante:", error);
            message.error("Erro ao atualizar o status do restaurante.");
        }
    };

    const handleCalendarUpdate = async (calendarId, values) => {
        try {
            const userId = secureLocalStorage.getItem("user_id");
            const formatTime = (time) => {
                if (time && /^\d{2}:\d{2}$/.test(time)) {
                    return time;
                }
                return null;
            };


            const calendarData = {
                start_morning: formatTime(values[`start_morning_${calendarId}`]) || formValues[`start_morning_${calendarId}`],
                finish_morning: formatTime(values[`finish_morning_${calendarId}`]) || formValues[`finish_morning_${calendarId}`],
                start_afternoon: formatTime(values[`start_afternoon_${calendarId}`]) || formValues[`start_afternoon_${calendarId}`],
                finish_afternoon: formatTime(values[`finish_afternoon_${calendarId}`]) || formValues[`finish_afternoon_${calendarId}`],
                start_night: formatTime(values[`start_night_${calendarId}`]) || formValues[`start_night_${calendarId}`],
                finish_night: formatTime(values[`finish_night_${calendarId}`]) || formValues[`finish_night_${calendarId}`],
                modified_by: userId
            };


            const filteredCalendarData = Object.fromEntries(
                Object.entries(calendarData).filter(([key, value]) => value !== null)
            );

            await updateRestaurantCalendarById(calendarId, filteredCalendarData);

            message.success("Horário atualizado com sucesso.");
        } catch (error) {
            console.error("Erro ao atualizar horário do restaurante:", error);
            message.error("Erro ao atualizar horário.");
        }
    };

    const handleFormChange = (changedValues, allValues) => {
        setFormValues(prevValues => ({
            ...prevValues,
            ...allValues
        }));
    };


    if (loading) {
        return (
            <div style={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!restaurantInfo) {
        return (
            <div style={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <p>Informações do restaurante não encontradas.</p>
            </div>
        );
    }

    const days = [
        { label: "Segunda", key: 1 },
        { label: "Terça", key: 2 },
        { label: "Quarta", key: 3 },
        { label: "Quinta", key: 4 },
        { label: "Sexta", key: 5 },
        { label: "Sábado", key: 6 },
        { label: "Domingo", key: 7 }
    ];

    return (
        <>
            {
                Object.keys(restaurantInfo).length > 0 && (
                    <div className="body_main">
                        <div className="container_home">
                            <Descriptions title="Informação do Restaurante" bordered>
                                <Descriptions.Item label="Nome">{restaurantInfo.name}</Descriptions.Item>
                                <Descriptions.Item label="Razão Social">{restaurantInfo.business_name}</Descriptions.Item>
                                <Descriptions.Item label="CNPJ">{restaurantInfo.tax_id}</Descriptions.Item>
                                <Descriptions.Item label="Endereço">{restaurantInfo.address}</Descriptions.Item>
                                <Descriptions.Item label="Número">{restaurantInfo.address_number}</Descriptions.Item>
                                <Descriptions.Item label="Complemento">{restaurantInfo.address_complement}</Descriptions.Item>
                                <Descriptions.Item label="CEP">{restaurantInfo.zipcode}</Descriptions.Item>
                                <Descriptions.Item label="Latitude">{restaurantInfo.latitude}</Descriptions.Item>
                                <Descriptions.Item label="Longitude">{restaurantInfo.longitude}</Descriptions.Item>
                            </Descriptions>

                            <div style={{ height: "80px", display: "flex", alignItems: "center" }}>
                                <span style={{ fontWeight: "700", margin: "5px" }}>
                                    Horário de funcionamento
                                </span>
                            </div>

                            {days.map(day => {
                                const dayCalendar = restaurantCalendars.find(calendar => calendar.weekday === day.key);

                                return (
                                    <Form
                                    key={day.key}
                                    initialValues={formValues}
                                    onValuesChange={handleFormChange}
                                    onFinish={(values) => handleCalendarUpdate(dayCalendar.id, values)}
                                >

                                    <Row style={{ alignItems: "center", display: "flex", border: "1px solid #d9d9d9", padding: "16px" }}>
                                        <Col className="grid-container" span={3}>
                                            <span>{day.label}</span>
                                        </Col>
                                        <Col className="grid-container" span={1}>
                                            <span>Manhã</span>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item
                                                name={`start_morning_${dayCalendar?.id}`}
                                                rules={[{
                                                    required: false,
                                                    validator: (rule, value) => {
                                                        if (value && !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
                                                            return Promise.reject('Insira um horário válido ex: 10:20');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }]}>
                                                <Input 
                                                style={{ width: "100%" }} 
                                                placeholder="Início manhã" 
                                                maxLength={5} 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9:]/g, '');
                                                }}
                                            />
                                            </Form.Item>
                                        </Col>
                                        <Col className="grid-container" span={1}>
                                            <span>às</span>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item
                                                name={`finish_morning_${dayCalendar?.id}`}
                                                rules={[{ required: false, message: "* Compo obrigatório" }, {
                                                    validator: (rule, value) => {
                                                        if (value && !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
                                                            return Promise.reject('Insira um horário válido ex(10:20)');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }]}>
                                                <Input 
                                                style={{ width: "100%" }}
                                                placeholder="Fim manhã" 
                                                maxLength={5} 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9:]/g, '');
                                                }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col className="grid-container" span={1}>
                                            <span>Tarde</span>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item

                                                name={`start_afternoon_${dayCalendar?.id}`}
                                                rules={[{ required: false, message: "* Compo obrigatório" }, {
                                                    validator: (rule, value) => {
                                                        if (value && !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
                                                            return Promise.reject('Insira um horário válido ex(10:20)');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }]}>
                                                <Input 
                                                style={{ width: "100%" }} 
                                                placeholder="Início tarde"
                                                maxLength={5} 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9:]/g, '');
                                                }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col className="grid-container" span={1}>
                                            <span>às</span>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item
                                                name={`finish_afternoon_${dayCalendar?.id}`}
                                                rules={[{ required: false, message: "* Compo obrigatório" }, {
                                                    validator: (rule, value) => {
                                                        if (value && !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
                                                            return Promise.reject('Insira um horário válido ex(10:20)');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }]}>
                                                <Input 
                                                style={{ width: "100%" }} 
                                                placeholder="Fim tarde"
                                                maxLength={5} 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9:]/g, '');
                                                }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col className="grid-container" span={1}>
                                            <span>Noite</span>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item

                                                name={`start_night_${dayCalendar?.id}`}
                                                rules={[{ required: false, message: "* Compo obrigatório" },
                                                {
                                                    validator: (rule, value) => {
                                                        if (value && !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
                                                            return Promise.reject('Insira um horário válido ex(10:20)');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }]}>
                                                <Input 
                                                style={{ width: "100%" }} 
                                                placeholder="Início noite"
                                                maxLength={5} 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9:]/g, '');
                                                }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col className="grid-container" span={1}>
                                            <span>às</span>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item

                                                name={`finish_night_${dayCalendar?.id}`}
                                                rules={[{ required: false, message: "* Compo obrigatório" },
                                                {
                                                    validator: (rule, value) => {
                                                        if (value && !/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
                                                            return Promise.reject('Insira um horário válido ex(10:20)');
                                                        }
                                                        return Promise.resolve();
                                                    }
                                                }]}>
                                                <Input 
                                                style={{ width: "100%" }} 
                                                placeholder="Fim noite"
                                                maxLength={5} 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9:]/g, '');
                                                }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col className="grid-container-bottom" span={2}>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit">Salvar</Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                                );
                            })}
                        </div>
                        <div style={{ width: "100%", height: 50, justifyContent: "center", display: "flex" }}>
                            <span style={{ marginRight: 50 }}>Restaurante está {checkRestaurant ? "ativo" : "inativo"}</span>
                            <Switch checked={checkRestaurant} onChange={onChange} />
                        </div>
                    </div>

                )

            }

        </>

    );
}
